module.exports = __webpack_public_path__ + "img/icon-plan-station.bc476181.svg";